var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 8,
    y: 2,
    fill: "#CBC8C8",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 13,
    y: 2,
    fill: "#CBC8C8",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 8,
    y: 8,
    fill: "#CBC8C8",
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 13,
    y: 8,
    fill: "#CBC8C8",
    rx: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 8,
    y: 14,
    fill: "#CBC8C8",
    rx: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 13,
    y: 14,
    fill: "#CBC8C8",
    rx: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 8,
    y: 20,
    fill: "#CBC8C8",
    rx: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 13,
    y: 20,
    fill: "#CBC8C8",
    rx: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrag);
export default __webpack_public_path__ + "static/media/icon_drag.919de899f2094824bd5aefe2a76ee933.svg";
export { ForwardRef as ReactComponent };